import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTerminals } from "redux/actions/terminalAction";
import { Welcome, Typography, MultiSelect, Select } from "components";
import {
  setSelectedTerminal,
  setSelectedTransactionTypes,
  getAllData,
} from "redux/actions/dashboard/terminalDashboardActions";
import { getUniqueTransactionTypes } from "utils/helper";
import {
  getAllTransactionsData,
  setTransactionQuery,
  getTransactionDetails,
} from "redux/actions/transactionActions";
import { getAgentAccount } from "redux/actions/agentAccountAction";

const TransactionHeader = ({ isTransactions, headerText }) => {
  const {
    user,
    terminals,
    isLoading,
    selectedTerminal,
    transactionTypes,
    transactionQuery,
    selectedTransactionTypes,
  } = useSelector((state) => ({
    user: state.user.user,
    terminals: state.terminalReducer.terminals,
    isLoading: state.asynReducer.isLoading,
    selectedTerminal: state.terminalDashboardReducer.selectedTerminal,
    transactionTypes: state.transactionsReducer.transactionTypes,
    transactionQuery: state.transactionsReducer.params,
    selectedTransactionTypes:
      state.terminalDashboardReducer.selectedTransactionTypes,
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    const requestParams = {
      agentId: user?.agent_id,
      size: 50,
    };
    dispatch(getTerminals(requestParams));

    return () => {
      setTransactionQuery({
        name: "type",
        value: [],
      });
      setSelectedTransactionTypes([], false);
    };
  }, [dispatch, user?.agent_id]);

  const terminalsToDisplay = terminals.length
    ? [
        { label: "All Terminals", value: "" },
        ...terminals.map(({ terminalId }) => ({
          label: `Terminal ${terminalId}`,
          value: terminalId,
        })),
      ]
    : [{ label: "No Active terminal" }];

  const handleTerminalChange = (value) => {
    setTransactionQuery({
      name: "terminalId",
      value,
    });
    setTransactionQuery({
      name: "pmNumber",
      value: "",
    });

    getAgentAccount({
      terminalId: value,
      agentId: user?.agent_id,
      status: "ENABLED",
      assigned: true,
    });
    getAllTransactionsData();
  };

  const transactionTypesToDisplay = isTransactions
    ? transactionQuery.type
    : selectedTransactionTypes;

  return (
    <div className="terminal-header-selections-container">
      <Welcome headerText={headerText} />
      <div className="terminal-header-selections">
        <div className="terminal-select-container d-flex align-items-center px-2 mb-3">
          <div>
            <Typography variant="body3" state="primary">
              Choose Terminal ID:{" "}
              <Select
                required={false}
                value={
                  isTransactions
                    ? transactionQuery.terminalId
                    : selectedTerminal
                }
                options={terminalsToDisplay}
                loading={isLoading}
                placeholder="All Terminals"
                onChange={(e) =>
                  isTransactions
                    ? handleTerminalChange(e.target.value)
                    : setSelectedTerminal(e.target.value)
                }
                name=""
              />
            </Typography>
          </div>
        </div>
        <div className="transaction-spec-container">
          {transactionTypes?.length ? (
            <div>
              <div
                className={`transaction-choice-container d-flex align-items-center px-2 mb-2 ${
                  isTransactions ? "transaction-choice-container__custom" : ""
                }`}
              >
                <Typography variant="body3">
                  {isTransactions
                    ? "Transaction Type:"
                    : "Choose Transaction Type:"}
                </Typography>{" "}
                <MultiSelect
                  placeholder={"All Transactions"}
                  // value={selectedTransactionTypes}
                  isSearchable={false}
                  clearable={false}
                  handleChange={(val) =>
                    isTransactions
                      ? setTransactionQuery({
                          name: "type",
                          value: val,
                        })
                      : setSelectedTransactionTypes(val, false)
                  }
                  options={getUniqueTransactionTypes(transactionTypes)?.map(
                    ({ type, description }) => ({
                      label: description,
                      value: type,
                    })
                  )}
                  onBlur={() =>
                    isTransactions ? getAllTransactionsData() : getAllData()
                  }
                  name="transaction-type-select"
                  borderStyle={"none"}
                />
              </div>
              <div
                className="d-flex justify-content-end flex-wrap mb-2"
                style={{ maxWidth: "15rem" }}
              >
                {transactionTypesToDisplay.length ===
                  getUniqueTransactionTypes(transactionTypes)?.length ||
                !transactionTypesToDisplay.length ? (
                  <Typography variant="caption0">All Transactions</Typography>
                ) : (
                  transactionTypesToDisplay.map((transaction, i) => (
                    <Typography variant="caption0" key={i}>
                      {transaction.label}
                      {i === transactionTypesToDisplay.length - 1
                        ? "."
                        : ","}{" "}
                      &nbsp;
                    </Typography>
                  ))
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          {isTransactions && (
            <div className="transaction-mode-container">
              <Typography variant="body3">
                Transaction Mode:{" "}
                <Select
                  placeholder="All"
                  required={false}
                  options={[
                    {
                      label: "All",
                      value: "",
                    },
                    {
                      label: "Cash",
                      value: "CASH",
                    },
                    {
                      label: "Card",
                      value: "CARD",
                    },
                  ]}
                  value={transactionQuery.transMode}
                  onChange={(e) => {
                    setTransactionQuery({
                      name: "transMode",
                      value: e.target.value,
                    });
                    getTransactionDetails();
                  }}
                />
              </Typography>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionHeader;
